import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'widgets/CheckBox';
import Icon from 'components/Icon';
import colors from 'assets/styles/jsVariables/colors';

const styles = {
  inputStyle: {
    width: '26px',
    marginRight: '16px',
    height: '35px',
    border: 'none'
  },
  checkedIconStyle: {
    width: '35px',
    height: '35px',
    fill: colors.lighterCyan,
    strokeWidth: 0.1,
    userSelect: 'none',
    flexShrink: 0
  },
  uncheckedIconStyle: {
    width: '26px',
    height: '25px',
    borderRadius: '2px',
    stroke: colors.lighterCyan
  }
};

function CheckBox(props) {
  const {
    style,
    onCheck,
    label,
    name,
    containerStyle,
    checkedIconStyle,
    uncheckedIconStyle,
    inputStyle,
    ...restProps
  } = props;
  return (
    <div style={containerStyle}>
      <Checkbox
        cssStyles={{
          root: inputStyle
        }}
        checkedIcon={<Icon name="checkbox-checked-icon" style={checkedIconStyle} />}
        icon={<Icon name="checkbox-outline" style={uncheckedIconStyle} />}
        onChange={onCheck}
        style={style}
        name={name}
        {...restProps}
      />
      <div
        style={{
          display: 'inline-block',
          fontSize: '16px',
          fontWeight: 600,
          fontFamily: 'proxima_novasemibold',
          color: colors.darkGrey,
          width: '80%',
          verticalAlign: 'top'
        }}
      >
        {label}
      </div>
    </div>
  );
}

CheckBox.propTypes = {
  onCheck: PropTypes.func,
  style: PropTypes.object,
  label: PropTypes.object,
  name: PropTypes.string,
  containerStyle: PropTypes.object,
  checkedIconStyle: PropTypes.object,
  uncheckedIconStyle: PropTypes.object,
  inputStyle: PropTypes.object
};

CheckBox.defaultProps = {
  style: {},
  label: {},
  name: '',
  containerStyle: {},
  checkedIconStyle: styles.checkedIconStyle,
  uncheckedIconStyle: styles.uncheckedIconStyle,
  inputStyle: styles.inputStyle
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/CheckBox/CheckBox.jsx